import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top synchronously before the next paint on every route change.
 * Uses useLayoutEffect (not useEffect) so the reset happens before the
 * browser paints the new route, eliminating the "scroll-then-jump" glitch
 * that occurs with lazy-loaded routes.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // Immediate reset (before paint)
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // Second reset after Suspense-resolved chunk mounts and layout runs
    const raf = requestAnimationFrame(() => window.scrollTo(0, 0));
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
}
